import {Outlet, Route, Routes, useLocation } from 'react-router-dom';
import './App.css';
import Blogs from './pages/blogs/Blogs';
import Clips from './pages/clips/Clips';
import Dating from './pages/dating/Dating';
import Events from './pages/events/Events';
import Forum from './pages/forum/Forum';
import Fundraisers from './pages/fundraisers/Fundraisers';
import Gigs from './pages/gigs/Gigs';
import Group from './pages/groups/Group';
import Home from './pages/Home.jsx/Home';
import Login from './pages/login/Login.jsx';
import Shop from './pages/shop/Shop';
import SignUp from './pages/signUp/SignUp.jsx';
import Live from './pages/live/Live';
import ChatRoom from './pages/chatRoom/ChatRoom';
import { createContext, useContext, useEffect, useState } from 'react';
import BlogDetails from './pages/blogs/blogDetails/BlogDetails';
import ClipsDetails from './pages/clips/clipsDetails/ClipsDetails';
import EventsDetails from './pages/events/eventsDetails/EventsDetails';
import FundraisersDetails from './pages/fundraisers/fundraisersDetails/FundraisersDetails';
import ForumDetails from './pages/forum/forumDetails/ForumDetails';

function ScrollToTop(){
  const { pathname } = useLocation();
  useEffect(()=>{
    window.scrollTo(0,0)
  }, [pathname]);
  return <Outlet />
}

export const ShowHideSitebar = createContext()

function App() {
  const [ sitebarStatus, setSitebarStatus ] = useState({
    pageName : '',
    home: { left: false, right: false },
    live: { left: false, right: false },
    clips: { left: false, right: false },
    shop: { left: false, right: false },
    gigs: { left: false, right: false },
    blogs: { left: false, right: false },
    forum: { left: false, right: false },
    group: { left: false, right: false },
    events: { left: false, right: false },
    fundraisers: { left: false, right: false },
    dating: { left: false, right: false },
    chatRoom: { left: false, right: false },
  })
  return (
    <ShowHideSitebar.Provider  value={[sitebarStatus, setSitebarStatus]}>
      <Routes>
        <Route  element={<ScrollToTop />}>
          <Route path="/login" element={<Login /> } />
          <Route path="/register" element={ <SignUp /> } />
          {/* Home  Pages */}
            <Route path="/" element={<Home />  } />
          {/* Live  Pages */}
            <Route path="/live" element={<Live />  } />
            {/* Clips Pages */}
            <Route path="/clips" element={ <Clips />} />
            <Route path="/clips/details/:id" element={ <ClipsDetails />} />
            {/* Shop pages */}
            <Route path='/shop' element={ <Shop />} />
            {/* Gigs pages */}
            <Route path='/gigs' element={ <Gigs />} />
            {/* Blogs pages */}
            <Route path="/blogs" element={ <Blogs />}  />
            <Route path="/blog/details/:id" element={<BlogDetails />} />
            {/* Forum Pages */}
            <Route path="/forum" element={<Forum />} />
            <Route path="/forum/details" element={<ForumDetails />} />
            {/* Groups Pages */}
            <Route path="/group" element={<Group />} />
            {/* Events pages */}
            <Route path="/events" element={<Events />} />
            <Route path="/events/details" element={<EventsDetails />} />
            <Route path="/events/details/:id" element={<EventsDetails />} />
            {/* Fundraisers Pages */}
            <Route path="/fundraisers" element={<Fundraisers />} />
            <Route path="/fundraisers/details/:id" element={<FundraisersDetails />} />
            <Route path="/fundraisers/details/:id/story" element={<FundraisersDetails />} />
            <Route path="/fundraisers/details/:id/perks" element={<FundraisersDetails />} />
            <Route path="/fundraisers/details/:id/team" element={<FundraisersDetails />} />
            <Route path="/fundraisers/details/:id/faq" element={<FundraisersDetails />} />
            <Route path="/fundraisers/details/:id/discussion" element={<FundraisersDetails />} />
            <Route path="/fundraisers/details/:id/updates" element={<FundraisersDetails />} />
            {/*Dating Pages  */}
            <Route path="/dating" element={<Dating />} />
            {/* ChatRoom Pages */}
            <Route path='/chatroom' element={<ChatRoom />} />
        </Route>
      </Routes>
      </ShowHideSitebar.Provider>
  );
}

export default App;
